import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.background};
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const GamesContainer = styled.div`
  padding: 12px;
  flex: 1;
`;

export const Row = styled.div`
  h2 {
    margin-left: 90px;
    margin-top: 15px;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
    font-size: 1.75rem;
  }
  > div {
    padding: 0 15px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    justify-items: center;
    align-items: center;
  }
  @media (max-width: 1470px) {
    > div {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
  @media (max-width: 1110px) {
    > div {
      grid-template-columns: 1fr 1fr;
    }
  }
  @media (max-width: 750px) {
    > div {
      padding: 0;
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 400px) {
    h2 {
      margin-left: 35px;
      font-size: 1.5rem;
    }
  }
`;
